// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"71ed61b7","238":"0b11a19c","644":"4116562a","732":"1e013f1c","865":"c83b6f02"}[chunkId] + ".chunk.js";
};